import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 4, 3),
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
  },
}))
